<template>
  <div class="collapse-container">
    <div class="collapse-item" @click="toggle">
      <div class="collapse-header">
        <div class="title">{{ id }}.{{ title }}</div>
        <div 
          class="img" 
          :style="{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.8s ease-in-out' }"
        >
          <img loading="lazy"  src="../../../static/img/aboutUs/top.png" alt="" v-if="isOpen">
          <img loading="lazy"  src="../../../static/img/aboutUs/bottom.png" alt="" v-if="!isOpen">
        </div>
      </div>
    </div>
    <!-- 动画过渡的内容 -->
    <div class="collapse-content" :class="{'expand': isOpen}">
      <div>{{ desc }}</div>
      <div v-show="desc1" class="desc1">{{ desc1 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
    },
    title: {
      type: String,
    },
    desc: {
      type: String,
    },
    desc1: {
      type: String,
    },
  },
  data() {
    return {
      isOpen: false, // 控制面板是否展开
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen; // 切换折叠面板的展开与收起
    },
  },
};
</script>

<style scoped lang="scss">
@import '/style/phone/aboutUs/collapseComponent.scss';
.collapse-container {
  background: #F4F4F6;
  padding: 2.5rem;
  margin: 0 auto;
  width: 70rem;
  // box-shadow: 0px 0.625rem 1.875rem 0px rgba(0, 0, 0, 0.05); /* 10px 30px */
  border-bottom: #E5E5E7;
  border-bottom: 1px solid #E5E5E7;
}
.collapse-container:last-child{
  border-bottom: none;
}
.collapse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.collapse-header .title {
  color:  #09080D;
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.collapse-header:hover {
  cursor: pointer; /* 鼠标指向时显示小手指 */
}

.img {
  border-radius: 50%;
  width: 2.25rem; /* 36px */
  height: 2.25rem; /* 36px */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.8s ease-in-out; /* 添加平滑的旋转过渡 */
}

img {
  width: 1.625rem;
  height: 1.625rem;
  display: block;
}

.collapse-content {
  color:  #09080D;
  font-family: Inter;
  font-size: 1rem;
  font-weight: 300;
  line-height: 150%; /* 24px */
  max-height: 0; /* 初始状态高度为0 */
  opacity: 0; /* 初始透明度为0 */
  overflow: hidden; /* 隐藏溢出内容 */
  transition: max-height 0.8s ease-in-out, opacity 0.8s ease-in-out; /* 平滑过渡 */
  transform-origin: top; /* 设置动画展开方向 */
}

.collapse-content.expand {
  max-height: 30rem; /* 调整为足够大的值，确保内容完全展开时动画更平滑 */
  opacity: 1; /* 完全显示 */
}
.desc1{
  margin-top: 0.75rem;
}
</style>
